import {z} from 'zod';
import {equipmentRegistrySchema,equipmentInspectionSchema} from './safety-program';
const id=z.string().regex(/^[A-Za-z0-9][A-Za-z0-9_-]{0,127}$/u);
export const equipmentCertificateAnalyzeSchema=z.object({siteId:id,aggregateId:id,mediaManifestId:id}).strict();
const field=z.string().trim().max(4000).nullable();
export const equipmentCertificateFactsSchema=z.object({name:field,type:field,model:field,serialNo:field,managementNo:field,
  manufacturer:field,location:field,capacity:field,inspectionAgency:field,inspectionType:field,
  date:field,nextDueDate:field,result:z.enum(['passed','passed-with-recommendation','failed','conditional']).nullable(),
  findings:field,certificateNo:field,sourceText:z.string().max(12000)}).strict();
export type EquipmentCertificateFacts=z.infer<typeof equipmentCertificateFactsSchema>;
export const equipmentCertificateRegisterSchema=z.object({siteId:id,analysisId:id,commandId:id,equipmentId:id,
  expectedEquipmentVersion:z.number().int().min(0),equipment:equipmentRegistrySchema,
  inspectionId:id,inspection:equipmentInspectionSchema}).strict();
export type EquipmentCertificateAnalysis={analysisId:string;aggregateId:string;facts:EquipmentCertificateFacts;
  matches:{id:string;version:number;name:string;managementNo:string;serialNo:string}[]};
